import styled from "@emotion/styled";

export const Button = styled.button`
  font-family:
    SF PRO,
    Helvetica,
    Arial,
    sans-serif;

  border: none;
  padding: 0;
  background-color: transparent;

  display: flex;
  flex-direction: column;
  width: max-content;
  gap: 4px;
  text-align: start;

  cursor: pointer;
  margin-left: 16px;
  margin-top: 12px;
`;

export const Text = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.1875;
  color: ${p => p.theme.colors.secondary.gray};
  padding-bottom: 2px;
  border-bottom: 2px dashed ${({ theme }) => theme.colors.secondary.gray};
`;
